module.exports = __webpack_public_path__ + "static/dr-jose-miguel-gomez-logos-4cd666c08a3348e95c944c5f04a90da0.svg";